import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { AssignIncidentComponent } from './assign-incident/assign-incident.component';
import { CreateIncidentComponent } from './create-incident/create-incident.component';
import { CreateWitnessReportComponent } from './create-witness-report/create-witness-report.component';
import { PriorityButtonComponent } from './edit-buttons/priority-button/priority-button.component';
import { TransitionButtonComponent } from './edit-buttons/transition-button/transition-button.component';
import { EditIncidentComponent } from './edit-incident/edit-incident.component';
import { DynamicFormComponent } from './forms/dynamic-form/dynamic-form.component';
import { DynamicViewComponent } from './forms/dynamic-view/dynamic-view.component';
import { IncidentFormComponent } from './forms/incident-form/incident-form.component';
import { LinkReportComponent } from './link-report/link-report.component';
import { LinkTripComponent } from './link-trip/link-trip.component';
import { AssignIncidentModalComponent } from './modals/assign-incident-modal/assign-incident-modal.component';
import { LinkReportModalComponent } from './modals/link-report-modal/link-report-modal.component';
import { LinkTripModalComponent } from './modals/link-trip-modal/link-trip-modal.component';
import { ViewIncidentComponent } from './view-incident/view-incident.component';
import { ViewWitnessReportComponent } from './view-witness-report/view-witness-report.component';
import { IncidentsRoutingModule } from './incidents-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiModule } from '../../ui/ui.module';
import { ClipboardModule } from 'ngx-clipboard';
import { WorkItemCommentViewComponent } from './work-item-comment-view/work-item-comment-view.component';
import { WorkItemCommentComponent } from './work-item-comment/work-item-comment.component';
import { IncidentTable2Component } from './incident-table2/incident-table2.component'
import { TableModule } from 'primeng/table';
import { PickReportTypeComponent } from './pick-report-type/pick-report-type.component';
import { SubmitExternalReportComponent } from './external/submit-external-report/submit-external-report.component';
import { WorkItemAttachmentsComponent } from './work-item-attachments/work-item-attachments.component';
import { TagDisplayComponent } from './tag-display/tag-display.component';
import { TagComponent } from './tag/tag.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { PanelModule } from 'primeng/panel';
import { SeverityImpactFormComponent } from './forms/severity-impact-form/severity-impact-form.component';
import { SeverityImpactDisplayComponent } from './components/severity-impact-display/severity-impact-display.component';


@NgModule({
  declarations: [
    HomeComponent,
    CreateIncidentComponent,
    CreateWitnessReportComponent,
    LinkReportComponent,
    LinkReportModalComponent,
    ViewIncidentComponent,
    IncidentFormComponent,
    EditIncidentComponent,
    AssignIncidentComponent,
    AssignIncidentModalComponent,
    ViewWitnessReportComponent,
    DynamicFormComponent,
    DynamicViewComponent,
    LinkTripComponent,
    LinkTripModalComponent,
    TransitionButtonComponent,
    PriorityButtonComponent,
    WorkItemCommentViewComponent,
    WorkItemCommentComponent,
    IncidentTable2Component,
    PickReportTypeComponent,
    SubmitExternalReportComponent,
    WorkItemAttachmentsComponent,
    TagDisplayComponent,
    TagComponent,
    SeverityImpactFormComponent,
    SeverityImpactDisplayComponent
  ],
  imports: [
    CommonModule,
    UiModule,
    IncidentsRoutingModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ClipboardModule,
    SplitButtonModule,
    DialogModule,
    ProgressSpinnerModule,
    SelectModule,
    InputTextModule,
    TextareaModule,
    ButtonModule,
    MessageModule,
    InputGroupModule,
    InputGroupAddonModule,
    PanelModule
  ]
})
export class IncidentsModule { }
